<template>
  <div class="button">{{ content }}</div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ",",
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  font-size: 18px;
  line-height: 25px;
  border: 5px solid #000000;
  box-sizing: border-box;
  border-radius: 30px;
  color: #000;
  padding: 10px 68px;
  text-align: center;
  &:hover {
    background: rgba(225, 225, 225, 0.45);
    cursor: url("../assets/mouse-hover.png"), pointer;
  }
}
</style>
